/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Namespaces for containers
 */
export enum Namespace {
    APP = 'CABLE/APP',
    OVERLAY = 'CABLE/OVERLAY',
    LM = 'CABLE/LM',
    AVC = 'CABLE/AVC',
}

/**
 * Product types (dsl,fiber, cable)
 */
export enum ProductType {
    DSL = 'dsl',
    FIBRE = 'fiber',
    CABLE = 'cable',
}

/**
 * TV Connect group (Start, Standard or Zuhause)
 */
export enum TvConnectGroup {
    START = 'start',
    START_PRESALE = 'pre-start',
    STANDARD = 'standard',
    STANDARD_PRESALE = 'pre-standard',
    ZUHAUSE = 'zuhause',
    ZUHAUSE_PRESALE = 'pre-zuhause',
}

/**
 * Jarvis price types
 */
export enum JarvisPriceType {
    ONCE = 'once',
    MONTHLY = 'monthly',
    STAIRWAY = 'stairway',
}

/**
 * URL query parameters
 */
export enum QueryNames {
    PRODUCT = 'product',
    GIGAKOMBI = 'gigakombi',
    FF = 'ffv2',
    BASKET = 'vfBasket',
    OPTION_BASKET = 'vfOptionBasket',
    CABLE_ACCESS = 'cableAccess',
    TARGET = 'target',
    TARGET_URL = 'targetURL',
    YOUNG = 'young',
    B_ID = 'b_id',
    THREE_P = '3p',
}

/**
 * Type of forms
 */
export enum FormType {
    ADDRESS = 'address',
    LM = 'lm',
}

/**
 * Vodafone domains
 */
export enum Domains {
    VF = 'https://eweb8.vfd2-testnet.de',
    ZUHAUSEPLUS = 'https://zuhauseplus.vodafone.de',
    ST = 'https://simplicity.wf-de.vodafone.com',
    JARVIS_DEV = 'https://jarvis-zuhauseplus-overview-k8s-wf-de-develop.wf-de.vodafone.com',
    JARVIS_CABLE = 'https://jarvis-cable-k8s-wf-de-develop.wf-de.vodafone.com',
}

/**
 * Vodafone endpoints
 */
export enum Endpoints {
    LOGIN_REDIRECT = '/api/login/',
    FRIENDS_AND_FAMILY = '/api/friends-and-family/validate',
    JARVIS_GET_TARIFFS = '/api/jarvis/zuhauseplus/v1/getProductDetails',
    JARVIS_CHECK_AVAILABILITY = '/api/jarvis/cable/v1/availabilityCheck',
    JARVIS_GET_ALTERNATIVE_PRODUCT = '/api/jarvis/cable/v1/getAlternativeProduct',
    JARVIS_VALIDATE_ADDRESS = '/api/jarvis/address/v1/validateAddress',
    JARVIS_DELETE_ADDRESS = '/api/jarvis/address/v1/deleteAddress/',
}

/**
 * CMS Placeholders
 */
export enum CmsPlaceholder {
    STAIRWAY_MONTH = '$month',
    PRICE = '$price',
    DOWNLOAD = '$download',
    UPLOAD = '$upload',
    DURATION = '$duration',
    DISCOUNTED_PRICE = '$discountedPrice',
    PRODUCT = '$product',
    PROMO_PRICE = '$promoPrice',
}

/**
 * Vodafone cookies
 */
export enum Cookies {
    ADDRESS = 'address',
    FF = 'vfhvalueffv2',
    BASKET = 'pdpBasket',
    ZHP_LM_MODULE = 'ftth',
    MDD_KEKS = 'MDDKeks',
    OSHOP = 'oshop',
    VP_CAPTCHA_QA_AUTHORIZATION = 'VpCaptchaQaAuthorization',
    TELLJA = 'adv_cb',
    THREE_P = '3p',
    GIGAKOMBI = 'vf-gigakombi',
    PLAYSTATION_PROMO = 'adv_ps5',
}

/**
 * Vodafone basket path
 */
export enum BasketPath {
    OPTION = '/optionen/',
    GIGAKOMBI = '/gigakombi/auth/',
}

/**
 * Selectors of the footnote HTMLs
 */
export enum FootnoteStyleSelector {
    ACCORDION_TITLE = 'tv-accordion-footnote-title',
    CONTENT_TITLE = 'tv-footnote-content-title',
    CONTENT = 'tv-footnote-content',
    FOOTNOTE_LINK = 'ws10-footnote-link-style',
    FOOTNOTE_LINK_TARGET = 'footnote-link-scroll-target',
}

/**
 * Jarvis error codes
 */
export enum JarvisError {
    CAPTCHA = 'ERROR_CAPTCHA_ERROR',
    INVALID_ADDRESS = 'ERROR_INVALID_ADDRESS',
}

/**
 * Cable provider types
 */
export enum CableProviderType {
    UME = 'ume',
    KDG = 'kdg',
}

/**
 * Notification type
 */
export enum NotificationType {
    SUCCESS = 'success',
    WARN = 'warn',
    INFO = 'info',
}

/**
 * Additional price fee text
 */
export enum FeeText {
    ROUTER_DELIVERY_FEE = 'Router-Versandkosten',
    PROVISION_FEE = 'Internet-Anschlusspreis',
}
